import styled from "styled-components";
import { lightColor, orangeColor, whiteColor } from "../../constants/colors";

const QuestionBlock = styled.div`
  //min-height: 100vh;
  flex-grow: 1;
  background: ${whiteColor};
  display: flex;
  flex-direction: column;
  padding-top: 65px;
  box-sizing: border-box;
`;

QuestionBlock.Progress = styled.div`
  margin-bottom: 42px;
  width: 100%;
`;

QuestionBlock.Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
  padding-bottom: 75px;
  @media (max-width: 767px) {
    padding-bottom: 37px;
  }
`;

QuestionBlock.Top = styled.div``;

QuestionBlock.Bottom = styled.div``;

QuestionBlock.Button = styled.div``;

QuestionBlock.Title = styled.div`
  ${(props) => {
    switch (props.type) {
      case 8:
        return `margin-bottom: 78px`;
      default:
        return `margin-bottom: 24px`;
    }
  }}
`;

QuestionBlock.Title.Add = styled.div`
  margin-top: 63px;
  margin-bottom: 29px;
`;

QuestionBlock.Answers = styled.div``;
QuestionBlock.Answer = styled.div`
  margin-bottom: 14px;
`;

QuestionBlock.Images = styled.div`
  display: flex;
  justify-content: space-between;
`;
QuestionBlock.Images.Item = styled.div`
  width: 49%;
  box-sizing: content-box;
`;
QuestionBlock.Images.Picture = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    max-width: 100%;
  }
`;
QuestionBlock.Images.Picture.Wrapper = styled.div`
  border: 2px solid transparent;
  border-radius: 16px;
  box-sizing: border-box;
  padding: 6px;
  margin-bottom: 6px;
  transition: 0.3s;
  border-color: ${(props) => (props.isActive ? orangeColor : "transparent")};
`;
QuestionBlock.Images.Text = styled.div``;

export { QuestionBlock };
